import { MapPin, CalendarDays, ArrowRight } from "lucide-react";

export default function Hero() {
  const scroll = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative overflow-hidden" data-testid="hero-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 pt-16 lg:pt-24 pb-16 lg:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7 reveal">
            <p className="overline mb-6" data-testid="hero-overline">
              Public consultation · pre-planning phase
            </p>
            <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#2A2B2A]" data-testid="hero-title">
              A proposed solar farm
              <span className="block text-[#3A4B3A]">north of Loughrea, Co. Galway.</span>
            </h1>
            <p className="mt-7 max-w-xl text-[15px] sm:text-base leading-relaxed text-[#2A2B2A]/85" data-testid="hero-subtitle">
              We are inviting the local community to learn about the project, ask
              questions of our team, and help shape the layout before a planning
              application is submitted to Galway County Council in Q3 2026.
            </p>

            <div className="mt-9 flex flex-wrap gap-3">
              <button
                onClick={() => scroll("book")}
                data-testid="hero-cta-book"
                className="inline-flex items-center gap-2 h-11 px-5 rounded-sm bg-[#3A4B3A] text-white text-sm font-medium hover:bg-[#2A3B2A] transition-colors"
              >
                <CalendarDays className="h-4 w-4" /> Information days
                <ArrowRight className="h-4 w-4 opacity-70" />
              </button>
              <button
                onClick={() => scroll("project")}
                data-testid="hero-cta-learn"
                className="inline-flex items-center gap-2 h-11 px-5 rounded-sm border border-[#4C4538] text-[#4C4538] text-sm font-medium hover:bg-[#4C4538] hover:text-white transition-colors"
              >
                Read the project briefing
              </button>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-x-7 gap-y-3 text-[13px] text-[#4C4538]">
              <span className="flex items-center gap-2">
                <MapPin className="h-3.5 w-3.5" /> 6.5 km north of Loughrea
              </span>
              <span className="flex items-center gap-2">
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#CBA365]" />
                Townlands of Sraheendoo, Brackloonbeg, Ben More & Galboley
              </span>
            </div>
          </div>

          <div className="lg:col-span-5 reveal">
            <div className="relative">
              <div className="aspect-[4/5] overflow-hidden rounded-sm border border-[#E0DCD3] bg-[#E9E6DF]">
                <img
                  src="https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=1400&q=80"
                  alt="Aerial view of a solar farm in rural fields"
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="absolute -bottom-5 -left-5 hidden sm:block bg-[#F9F8F6] border border-[#E0DCD3] rounded-sm p-4 max-w-[240px] shadow-sm">
                <p className="overline mb-2">What it looks like</p>
                <p className="font-serif-display text-lg leading-snug">
                  A working solar farm — quiet, low‑profile, surrounded by the fields it sits in.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
